import { render } from "./pc.vue?vue&type=template&id=5e4c622d&scoped=true"
import script from "./pc.vue?vue&type=script&lang=js"
export * from "./pc.vue?vue&type=script&lang=js"

import "./pc.vue?vue&type=style&index=0&id=5e4c622d&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e4c622d"]])

export default __exports__